import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {RacunDocument} from "./RacunDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {ZahtevZaPovratPotpunDocument} from "./ZahtevZaPovratPotpunDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor, datum valute, iznos
// opciono: opis, lista priloga, tekući račun

export const zahtevZaPovratPotpunDocumentFields: IntercateKeysMap<RacunDocument, EntityField<ZahtevZaPovratPotpunDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	dueDate: {
		name: "dueDate", dataType: EntityFieldDataType._date, label: "Datum valute",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	amount: {
		name: "amount", dataType: EntityFieldDataType._number, label: "Iznos",
		validator: { required: true },
		sortable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj tekućeg računa",
		validator: { required: false },
		sortable: true
	},
	selectedForPayment: {
		name: "selectedForPayment", dataType: EntityFieldDataType._boolean, label: "Selektovan za plaćanje",
		validator: { required: false },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<RacunDocument>> = [
	zahtevZaPovratPotpunDocumentFields.indexingNumber,
	zahtevZaPovratPotpunDocumentFields.indexingDate,
	zahtevZaPovratPotpunDocumentFields.documentNumber,
	zahtevZaPovratPotpunDocumentFields.documentDate,
	zahtevZaPovratPotpunDocumentFields.assignedTo,
	zahtevZaPovratPotpunDocumentFields.clientId,
	zahtevZaPovratPotpunDocumentFields.sectorId,
	zahtevZaPovratPotpunDocumentFields.tags,
	zahtevZaPovratPotpunDocumentFields.description,
	zahtevZaPovratPotpunDocumentFields.dueDate,
	zahtevZaPovratPotpunDocumentFields.amount,
	zahtevZaPovratPotpunDocumentFields.accountNumber,
	zahtevZaPovratPotpunDocumentFields.selectedForPayment,
	zahtevZaPovratPotpunDocumentFields.parentId
]

export const zahtevZaPovratPotpunDocumentFieldsDescriptor: EntityFieldsDescriptor<ZahtevZaPovratPotpunDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
